(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description-optimized"] && !Shopify.designMode) return;
  try {
    const initializeResponsiveDescriptionImages = (root = document) => {
    root.querySelectorAll('img[data-responsive-description-image]').forEach((image) => {
      if (image.dataset.responsiveImageReady === 'true') return;

      const source = new URL(image.getAttribute('src'), window.location.origin);
      const isShopifyImage =
        source.hostname.includes('cdn.shopify.com') || source.pathname.includes('/cdn/shop/files/');

      if (!isShopifyImage) return;

      const urlAtWidth = (width) => {
        const sizedSource = new URL(source.href);
        sizedSource.searchParams.set('width', width);
        return sizedSource.href;
      };

      image.srcset = [360, 540, 750, 900].map((width) => `${urlAtWidth(width)} ${width}w`).join(', ');
      image.sizes = '(max-width: 749px) calc(100vw - 3rem), 650px';
      image.src = urlAtWidth(900);
      image.dataset.responsiveImageReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeResponsiveDescriptionImages(), { once: true });
  } else {
    initializeResponsiveDescriptionImages();
  }

  document.addEventListener('shopify:section:load', (event) => initializeResponsiveDescriptionImages(event.target));
  } catch(e) { console.error(e); }
})();

})();
